class BarBlockService {
  getLabels (strataDefinition, stratifyBy) {
    if (strataDefinition && Array.isArray(strataDefinition.options) && stratifyBy) {
      const currentStrata = strataDefinition.options.find((option) => (option.value === stratifyBy))
      if (currentStrata && Array.isArray(currentStrata.legend)) {
        return currentStrata.legend
      }
    }
  }

  transformToTableData (data, dataDefinition = {}, selections = {}, { columnsToHide = {}, labels = [] }) {
    const rowField = dataDefinition.xField
    const columnField = (selections.strata === undefined) ? dataDefinition.groupField : selections.strata
    const labelsHash = labels.reduce((labelsHash, { value, label }) => {
      labelsHash[value] = label
      return labelsHash
    }, {})
    return data
      .map((d) => {
        let column = (columnField === dataDefinition.emptyValue || d[columnField] === undefined) ? 'Overall' : d[columnField]
        if (labelsHash[column]) {
          column = labelsHash[column]
        }
        const dataPoint = {
          row: d[rowField].toString(),
          column,
          ...d
        }
        return dataPoint
      })
      .filter((d) => (!columnsToHide[d.column]))
  }
}

export const barBlockService = new BarBlockService()
